import React from 'react'
import {render} from 'react-dom'
import 'babel-polyfill'
import Root from './components/Root'
import './settings/settings'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import registerServiceWorker from './settings/registerServiceWorker'

if (module.hot) {
    module.hot.accept();
}

render(<Root />, document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/index.js